<div
  *ngIf="content.isError || content.isSuccess"
  class="form-alert"
  id="formAlertId"
>
  <idp-form-alert
    [message]="content.message"
    [successIcon]="content.isSuccess"
    [showCloseButton]="true"
    (closePopup)="onClosePopup()"
  ></idp-form-alert>
</div>
<idp-login-header
  [ngClass]="{
    'login-header-margin':
      content.formAttributes.errorAlertBanner &&
      content.formAttributes.submitAttempt
  }"
  [loginHeaderContent]="content.pageContent.pageHeader"
></idp-login-header>
<ng-container
  *ngIf="
    content.formAttributes.submitAttempt &&
    content.formAttributes.errorAlertBanner &&
    content.formAttributes.errorCount
  "
>
  <idp-alert-warning
    #alertWarning
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
    [cntError]="content.formAttributes.errorCount"
    [errorMessage]="content.pageContent.errors.alertWarning"
  ></idp-alert-warning>
</ng-container>
<form
  [formGroup]="addEmailAddressForm"
  id="addEmailAddressForm"
  class="add-email-address"
  (ngSubmit)="onSubmit()"
>
  <div class="add-email-address__content">
    <div class="add-email-address__content__email">
      <idp-input
        [labelTxt]="content.pageContent.emailLabel"
        formControlName="email"
        id="email"
        (value)="onChange()"
        (focusOut)="onFocussedOut('email')"
      ></idp-input>
      <!-- TODO: replace with error mesage component-->
      <div *ngIf="showErrorMessageEmail" class="error-message__email">
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.emailErrorMessage[emailControlErrors]
          "
        ></span>
      </div>
    </div>
    <div class="add-email-address__content__confirm-email">
      <idp-input
        [labelTxt]="content.pageContent.confirmEmailLabel"
        formControlName="confirmEmail"
        id="confirmEmail"
        (value)="onChange()"
        (focusOut)="onFocussedOut('confirmEmail')"
      ></idp-input>
      <span
        *ngIf="showOnEmailsMismatch || showOnEmailsMatch"
        class="add-email-address__content__confirm-email--default-mismatch"
        [ngClass]="{ match: showOnEmailsMatch }"
      ></span>
      <!-- TODO: replace with error mesage component-->
      <div
        *ngIf="showErrorMessageConfirmEmail"
        class="error-message__confirm-email"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.confirmEmailErrorMessage[
              confirmEmailControlErrors
            ]
          "
        ></span>
      </div>
    </div>
  </div>
  <div class="add-email-address__submit-btn">
    <idp-button
      [elementType]="'submit'"
      [ariaLabel]="content.pageContent.buttonLabel"
      [label]="content.pageContent.buttonLabel"
      [size]="'full-width'"
      [disabled]="content.formAttributes.disableActionButton"
    ></idp-button>
  </div>
</form>
